import * as Scrivito from "scrivito";

const HeroSliderWidget = Scrivito.provideWidgetClass("HeroSliderWidget", {
  attributes: {
    dotsDescription: "string",
    panels: ["widgetlist", { only: "TextImagePanelWidget" }],
    background: ["enum", { values: ["blue", "teal"] }],
  },
  extractTextAttributes: ["panels", "dotsDescription"],
});

export default HeroSliderWidget;
